import { IconColors } from '../../icon';

export const HorizontalTabTypes = {
  TEXT_TAB: 'text-tab',
  PRIMARY_TAB: 'primary-tab',
  TERTIARY_TAB: 'tertiary-tab',
  SECONDARY_TAB: 'secondary-tab',
  PRIMARY_PILL_TAB: 'primary-pill-tab',
};

export const HorizontalTabVisualTypes = {
  TEXT: 'text',
  DEFAULT: 'default',
};

export const HorizontalTabScrollTypes = {
  ARROW: 'arrow',
  CHEVRON: 'chevron',
  CHEVRON_OUTLINED: 'chevron-OUTLINED',
};

export const SelectedTabIconColors = {
  [HorizontalTabTypes.TEXT_TAB]: IconColors.PRIMARY,
  [HorizontalTabTypes.SECONDARY_TAB]: IconColors.GREY,
  [HorizontalTabTypes.TERTIARY_TAB]: IconColors.PRIMARY,
};
